var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible && _vm.commandType,
      expression: "visible && commandType"
    }],
    ref: "contextMenu",
    staticClass: "contextMenu",
    style: {
      'left': `${_vm.posX}px`,
      'top': `${_vm.posY}px`
    },
    attrs: {
      "id": "editorContextMenu"
    },
    on: {
      "contextmenu": _vm.browserContextMenuLock
    }
  }, [_c('ul', [_vm.slctType == 'single' ? [!_vm.readonlyFlag ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.modify
    }
  }, [_vm._v("변경하기")]) : _vm._e(), !_vm.isVisualization ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.callConnectProtocol
    }
  }, [_vm._v("프로토콜 연결하기")]) : _vm._e(), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.info
    }
  }, [_vm._v("속성정보 보기")]), !_vm.readonlyFlag ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.callEditAttribute
    }
  }, [_vm._v("속성정보 편집")]) : _vm._e(), !_vm.readonlyFlag ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.selectionDelete
    }
  }, [_vm._v("선택한 태그 삭제")]) : _vm._e()] : _vm._e()], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }